import Button from "@pathwright/ui/src/components/button/Button"
import ButtonGroup from "@pathwright/ui/src/components/button/ButtonGroup"
import IconButton from "@pathwright/ui/src/components/button/IconButton"
import classnames from "classnames"
import ConnectStores from "lib/core/store/components/ConnectStores"
import { Component } from "react"
import { VelocityComponent } from "velocity-react"
import "./PathListInsert.css"
import PathListPaste from "./PathListPaste"
import PathGroupFormContainer from "./group/PathGroupFormContainer"
import PathTopicFormContainer from "./topic/PathTopicFormContainer"

class PathListInsert extends Component {
  state = { isAdding: false }

  get isAdding() {
    const { selection, order } = this.props
    return (
      (selection &&
        !selection.id &&
        !selection.parent &&
        !selection.parent_id &&
        selection.order === order) ||
      (!selection && this.state.isAdding)
    )
  }

  get isEditing() {
    return (
      this.isAdding &&
      !!this.props.selection &&
      !!this.props.selection.item_type
    )
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextState) {
    // Finished successfully pasting item
    const selectionPasted =
      this.props.pasting_selection &&
      !nextProps.pasting_selection &&
      !nextProps.selection_error
    // Selection created
    const selectionCreated =
      !!this.props.selection &&
      !this.props.selection.id &&
      !!nextProps.selection &&
      !!nextProps.selection.id
    // Unselected selection
    const selectionUnselected =
      !this.props.pasting_selection &&
      !!this.props.selection &&
      !nextProps.selection

    if (
      this.isAdding &&
      (selectionPasted || selectionCreated || selectionUnselected)
    ) {
      this.setState({ isAdding: false })
    }
  }

  toggleAdding = () => {
    this.setState({ isAdding: !this.state.isAdding })

    if (this.isAdding) {
      return this.props.unSelectPathItem()
    } else {
      return this.props.selectNewPathItem({ order: this.props.order })
    }
  }

  render() {
    const { selection, order, selectNewItem, unSelectPathItem } = this.props
    const className = classnames("PathListInsert", {
      "PathListInsert--active": this.isAdding || this.isEditing
    })

    const buttonProps = {
      styleType: "secondary",
      size: "large",
      inverted: true
    }

    return (
      <div className={className}>
        <div className="PathListInsert__Button-wrapper">
          <IconButton
            className="PathListInsert__Toggle"
            rotate={this.isAdding ? 45 : undefined}
            onClick={this.toggleAdding}
            icon="plus-circle"
            size={30}
            inverted={true}
          />
        </div>
        {this.isAdding ? (
          <VelocityComponent>
            <div style={{ paddingTop: "15px" }}>
              {(() => {
                if (this.isEditing) {
                  switch (selection.item_type) {
                    case "T":
                      return (
                        <PathTopicFormContainer
                          actionLabel="Create Divider"
                          onCancel={unSelectPathItem}
                        />
                      )
                    case "G":
                      return (
                        <PathGroupFormContainer
                          actionLabel="Create Lesson"
                          onCancel={unSelectPathItem}
                        />
                      )
                  }
                } else {
                  return (
                    <ButtonGroup className="PathListInsert__Options">
                      <div className="PathListInsert__Button">
                        <Button
                          {...Object.assign(
                            {
                              className: "PathListInsert__Add"
                            },
                            buttonProps,
                            {
                              rounded: false,
                              onClick: () => selectNewItem("G")
                            }
                          )}
                        >
                          Add a lesson
                        </Button>
                        <PathListPaste order={order} size={60} type="G" />
                      </div>
                      <div className="PathListInsert__Button">
                        <Button
                          {...Object.assign(
                            {
                              className: "PathListInsert__Add"
                            },
                            buttonProps,
                            {
                              rounded: false,
                              onClick: () => selectNewItem("T")
                            }
                          )}
                        >
                          Add a divider
                        </Button>
                        <PathListPaste order={order} size={60} type="T" />
                      </div>
                    </ButtonGroup>
                  )
                }
              })()}
            </div>
          </VelocityComponent>
        ) : undefined}
      </div>
    )
  }
}

const mapStateToProps = function (state, ownProps) {
  const { selection, pasting_selection, selection_error } =
    state.pathAdminStore.state
  const { selectNewPathItem, unSelectPathItem } = state.pathAdminStore.action

  const selectNewItem = function (type) {
    const data = {
      item_type: type,
      order: ownProps.order
    }
    return selectNewPathItem(data)
  }

  const props = _.assign(
    {},
    {
      // state
      selection,
      pasting_selection,
      selection_error,
      // actions
      selectNewItem,
      unSelectPathItem,
      selectNewPathItem
    },
    ownProps
  )
  return props
}

const stores = [
  {
    store: "pathAdmin",
    watch: [
      "selection",
      "editing_selection",
      "pasting_selection",
      "selection_error"
    ]
  }
]

PathListInsert.displayName = "PathListInsert"
export default ConnectStores(PathListInsert, stores, {}, mapStateToProps)
